// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartBackSideConfiguration.js"
// company="Izenda">  Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { get, compact, getOr, isNil } from 'lodash/fp';

import GridLayout from 'share/components/controls/Izenda.GridLayout';

import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';
import containerFactories from 'share/factories/Izenda.ReportPartFieldContainerFactories';

import LabelFieldContainer from './FieldContainers/Izenda.LabelFieldContainer';

@connect()
export default class ReportPartBackSideConfiguration extends Component {
  static propTypes = {
    store: PropTypes.object,
    reportPart: PropTypes.object
  };

  render() {
    const props = this.props;

    const containers = this.getContainers();
    const createContainer = ({ component, key, ...others }) => {
      const Comp = component || LabelFieldContainer;
      return <Comp key={key} {...others} {...props} />;
    };

    return (
      <GridLayout className="izenda-ReportPartConfiguration u_paddingBottom">
        {containers.map(createContainer)}
      </GridLayout>
    );
  }

  getContainers() {
    const {
      reportPart: { reportPartContent }
    } = this.props;

    const reportPartStyle = reportPartContent.reportPartStyle;
    const reportPartType = reportPartContent.type;
    const { fieldContainerSchema } = cfgFactories.getConfiguration(reportPartType, reportPartStyle);

    const confSchemas = fieldContainerSchema(reportPartContent);

    const containers = confSchemas.map(s => {
      const key = Object.keys(s)[0];
      return key ? containerFactories.create(key, s[key]) : undefined;
    });

    return compact(containers);
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ReportPartBackSideConfiguration.js